import React from "react";
import { getLocalString, localNames } from "utils/localisation.service";
import { useSelector } from 'react-redux';

function renderSwitch(param, locales) {
    switch (param) {
        // Ακύρωση Αίτησης
        case 'task.name.application_cancellation':
            return <div className="application-badge cancel-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_CANCELLATION)}</span></div>; 
        // Επιστροφή στον Δικαιούχο
        case 'task.name.application_return_to_beneficiary':
            return <div className="application-badge return-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_RETURN_TO_BENEFICIARY)}</span></div>; 
        //Υποβολή Αίτησης
        case 'task.name.submit_application':
            return <div className="application-badge start-badge"><span>{getLocalString(locales, localNames.TASK_NAME_SUBMIT_APPLICATION)}</span></div>;
        //Αξιολόγηση Αίτησης
        case 'task.name.audit_application':
            return <div className="application-badge audit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_AUDIT_APPLICATION)}</span></div>;
        //Προσωρινή Ένταξη
        case 'task.name.temporary_approval':
            return <div className="application-badge evaluate-badge"><span>{getLocalString(locales, localNames.TASK_NAME_TEMP_APPROVAL)}</span></div>; 
        //Απένταξη Αίτησης
        case 'task.name.application_withdrawal':
            return <div className="application-badge edit-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_WITHDRAWAL)}</span></div>;  
        //Έναρξη Προγράμματος
        case 'task.name.program_initiation':
            return <div className="application-badge completion-badge"><span>{getLocalString(locales, localNames.TASK_NAME_PROGRAM_START)}</span></div>;
            //Απόρριψη Αίτησης
        case 'task.name.application_rejection':
            return <div className="application-badge cancel-badge"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTION)}</span></div>; 
        default:
            return null;
    }
}

const StatusTag = (props) => {
    const locales = useSelector(state => state.forms?.localeStrings);
    return renderSwitch(props.status, locales);
}

export default StatusTag;